'use strict';
/* global fetch, btoa, Headers */

var _regeneratorRuntime = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("D:/Projects/Ukemi/ukemi.ninja-2019/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var core = require('./core');

var StatusError = /*#__PURE__*/function (_Error) {
  _inherits(StatusError, _Error);

  var _super = _createSuper(StatusError);

  function StatusError(res) {
    var _this;

    _classCallCheck(this, StatusError);

    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), StatusError);
    }

    _this.name = 'StatusError';
    _this.message = res.statusMessage;
    _this.statusCode = res.status;
    _this.res = res;
    _this.json = res.json.bind(res);
    _this.text = res.text.bind(res);
    _this.arrayBuffer = res.arrayBuffer.bind(res);
    var buffer;

    var get = function get() {
      if (!buffer) buffer = _this.arrayBuffer();
      return buffer;
    };

    Object.defineProperty(_assertThisInitialized(_this), 'responseBody', {
      get: get
    }); // match Node.js headers object

    _this.headers = {};

    var _iterator = _createForOfIteratorHelper(res.headers.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];

        _this.headers[key.toLowerCase()] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _this;
  }

  return StatusError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var mkrequest = function mkrequest(statusCodes, method, encoding, headers, baseurl) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_url, body) {
      var _headers,
          parsed,
          resp,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _headers = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              _url = baseurl + (_url || '');
              parsed = new URL(_url);
              if (!headers) headers = {};

              if (parsed.username) {
                headers.Authorization = 'Basic ' + btoa(parsed.username + ':' + parsed.password);
                parsed = new URL(parsed.protocol + '//' + parsed.host + parsed.pathname + parsed.search);
              }

              if (!(parsed.protocol !== 'https:' && parsed.protocol !== 'http:')) {
                _context.next = 7;
                break;
              }

              throw new Error("Unknown protocol, ".concat(parsed.protocol));

            case 7:
              if (!body) {
                _context.next = 17;
                break;
              }

              if (!(body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === 'string')) {
                _context.next = 11;
                break;
              }

              _context.next = 17;
              break;

            case 11:
              if (!(typeof body === 'object')) {
                _context.next = 16;
                break;
              }

              body = JSON.stringify(body);
              headers['Content-Type'] = 'application/json';
              _context.next = 17;
              break;

            case 16:
              throw new Error('Unknown body type.');

            case 17:
              _headers = new Headers(_objectSpread(_objectSpread({}, headers || {}), _headers));
              _context.next = 20;
              return fetch(parsed, {
                method: method,
                headers: _headers,
                body: body
              });

            case 20:
              resp = _context.sent;
              resp.statusCode = resp.status;

              if (statusCodes.has(resp.status)) {
                _context.next = 24;
                break;
              }

              throw new StatusError(resp);

            case 24:
              if (!(encoding === 'json')) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", resp.json());

            case 28:
              if (!(encoding === 'buffer')) {
                _context.next = 32;
                break;
              }

              return _context.abrupt("return", resp.arrayBuffer());

            case 32:
              if (!(encoding === 'string')) {
                _context.next = 36;
                break;
              }

              return _context.abrupt("return", resp.text());

            case 36:
              return _context.abrupt("return", resp);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

module.exports = core(mkrequest);